import React, { FC, lazy, Suspense, useEffect, useState } from 'react'
import { FallbackScreen } from '../../comps/FallBackScreen'
import { useLazyApiData, useStores } from '../../data/store'
import { PAYMENT_MODE_SUBTYPES, TEMPLATE } from '../../utils/constants'

const TOneCorpNetBanking = lazy(() => import('./TOneCorpNetBanking'))
const CorpNetBankingComp = lazy(() => import('./CorpNetBankingComp'))

const Wallet: FC = () => {
  const {
    getInstruments,
    getInstrumentList,
    theme,
    template,
    getConvenienceApi,
    getCorpNBConvenienceData,
    isConFeeAvailable,
    offerApplied,
  } = useStores((root) => ({
    getInstruments: root.getInsturmentsApi,
    getInstrumentList: root.getInstrumentsList,
    theme: root?.config?.merchantTheme,
    template: root?.merchant.template,
    getConvenienceApi: root?.getConvenienceApi,
    getCorpNBConvenienceData: root?.getCorpNBConvenienceData,
    isConFeeAvailable: root.transaction.isConFeeAvailable,
    offerApplied: root.isOfferApplied,
  }))

  const [initialLoading, setInitialLoading] = useState(true)
  const [lazyInsrtumentsApi, { state: instrumentsState, data: instrumentsData }] = useLazyApiData(getInstruments)
  const [lazyGetConvenienceFee] = useLazyApiData(getConvenienceApi)

  const isOfferApplied = offerApplied(PAYMENT_MODE_SUBTYPES.CORP_NB)

  useEffect(() => {
    if (getInstrumentList(PAYMENT_MODE_SUBTYPES.CORP_NB).length === 0) {
      lazyInsrtumentsApi(PAYMENT_MODE_SUBTYPES.CORP_NB)
    }
  }, [getInstrumentList, lazyInsrtumentsApi])

  useEffect(() => {
    if (!isConFeeAvailable(PAYMENT_MODE_SUBTYPES.CORP_NB, isOfferApplied)) {
      lazyGetConvenienceFee(getCorpNBConvenienceData(), PAYMENT_MODE_SUBTYPES.CORP_NB, isOfferApplied)
    }
  }, [getCorpNBConvenienceData, isConFeeAvailable, isOfferApplied, lazyGetConvenienceFee])

  useEffect(() => {
    setTimeout(() => {
      setInitialLoading(false)
    }, 500)
  }, [])

  const NBCompObj: any = {
    [TEMPLATE.MILK_BASKET]: TOneCorpNetBanking,
    default: CorpNetBankingComp,
  }

  const CompName = NBCompObj[template?.id] ?? NBCompObj.default

  return (
    <Suspense fallback={<FallbackScreen />}>
      <CompName
        theme={theme}
        instrumentsState={instrumentsState}
        fetchInstrumentApi={() => lazyInsrtumentsApi(PAYMENT_MODE_SUBTYPES.CORP_NB)}
        initialLoading={initialLoading}
        message={instrumentsData?.message}
      />
    </Suspense>
  )
}

export default Wallet
